import { isValidUUID } from '../utils/string-helpers.js';
/**
 * Returns a where clause depending on if provided id is a UUID or an old mongoId.
 */
export const getExternalIdWhereClause = (itemId) => {
    const isUuid = isValidUUID(itemId);
    return {
        ...(isUuid && { _id: { _eq: itemId } }),
        ...(!isUuid && { external_id: { _eq: itemId } }),
    };
};
/**
 * Helper function to build filters for fields that could be uuids or mongo ids
 * Avoids sending "_id: { _in:[] }" as that will just return []
 *
 * @example
 * buildOrConditionsForExternalIds([
 *   '123',
 *   '456',
 *   'b3b8c7e2-8f2a-4c1a-9e2b-1a2b3c4d5e6f', // valid UUID
 *   'e4d909c2-2f8e-4c1a-9e2b-1a2b3c4d5e6f', // valid UUID
 * ])
 * // {
 * //   _or: [
 * //     { _id: { _in: ['b3b8c7e2-8f2a-4c1a-9e2b-1a2b3c4d5e6f', 'e4d909c2-2f8e-4c1a-9e2b-1a2b3c4d5e6f'] } },
 * //     { mongo_id: { _in: ['123', '456'] } }
 * //   ]
 * // }
 *
 * TODO: We have "external_id" for some tables but not all (neighborhoods, program_tags)
 * Currently going with mongo_id for now but we might want to add external_id to any tables missing it
 */
export const buildOrConditionsForExternalIds = (ids) => {
    const uuids = ids?.filter(isValidUUID);
    const nonUuids = ids?.filter(id => !isValidUUID(id));
    const conditions = [];
    if (uuids?.length)
        conditions.push({ _id: { _in: uuids } });
    if (nonUuids?.length) {
        conditions.push({ mongo_id: { _in: nonUuids } });
    }
    return conditions.length ? { _or: conditions } : {};
};
